import { CancellablePromise, del, get, post } from "@/api";
import type { Dictionary } from "@/types";

export function getDictionaries(): CancellablePromise<Dictionary[]> {
  return get<Dictionary[]>("/v1/me/dictionaries/favorites");
}

export function getDictionaryIds(): CancellablePromise<string[]> {
  return getDictionaries().then((dictionaries) => dictionaries.map((dictionary) => dictionary.id));
}

export function addDictionary(dictionaryId: string): CancellablePromise<void> {
  return post("/v1/me/dictionaries/favorites", { dictionaryId });
}

export function removeDictionary(dictionaryId: string): CancellablePromise<void> {
  return del(`/v1/me/dictionaries/favorites/${dictionaryId}`);
}
